import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Form, Input, message } from 'antd';

const PayInvoiceModal = ({ open, onCancel, handlePayInvoice }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  useEffect(() => {
    if (!open) {
      form.resetFields();
    }
  }, [open, form]);

  const handleSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        handlePayInvoice(values.amount);
      })
      .catch(() => {
        message.error(t('subscriptions.amountInvalid'));
      });
  };

  return (
    <Modal
      title={t('subscriptions.payInvoice')}
      open={open}
      onCancel={onCancel}
      onOk={handleSubmit}
      okText={t('common.ok')}
      cancelText={t('common.cancel')}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label={t('subscriptions.credit')}
          name="amount"
          rules={[{ required: true, message: t('subscriptions.amountRequired') }]}
        >
          <Input type="number" placeholder={t('subscriptions.amountPlaceholder')} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default PayInvoiceModal;
